import util from '../lib/util';
import * as DateUtil from '../lib/dateutils';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class EthicalWall extends Base implements EntityType {
    ethicalWallId: uuid;
    matterId: uuid;
    userId: uuid;
    reason: string;
    addedAt: Date;
    conflictId?: uuid | null;
    constructor(doc: typeof EthicalWall | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            ethicalWallId: genUUID(),
            matterId: null,
            userId: null,
            reason: null,
            addedAt: new Date(),
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "ethicalWall";
        // @ts-ignore
        this.ethicalWallId = doc._ethicalWallId || doc.ethicalWallId || doc.ethicalwallid || genUUID();
        // @ts-ignore
        this.matterId = doc._matterId || doc.matterId || doc.matterid || null;
        // @ts-ignore
        this.userId = doc._userId || doc.userId || doc.userid || null;
        // @ts-ignore
        this.reason = doc._reason || doc.reason || null;
        // @ts-ignore
        this.addedAt = DateUtil.timestampOnly(doc._addedAt) || DateUtil.timestampOnly(doc.addedAt) || DateUtil.timestampOnly(doc.addedat) || new Date();
        // @ts-ignore
        this.conflictId = doc._conflictId || doc.conflictId || doc.conflictid || null;
    }
    get id(): uuid { return this.ethicalWallId; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique id for this Ethical Wall"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","comment":"Associated firm"}]; }
    toLowerCase() { return this.ethicalWallId; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): EthicalWall[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'ethicalWall',
    table: 'ETHICAL_WALL',
    clientStore: false,
    // Ethical Walls are owner/admin metadata, outside Role Data Area privileges.
    comment: 'An Ethical Wall blocks a person from a Case, including owners and admins. A Case can have several walls. Only owners and admins can manage walls, and cannot remove their own wall.',
    fields: {
        ethicalWallId: {
            type: 'uuid', required: true, pk: true, default: '__UUID__',
            comment: 'Unique id for this Ethical Wall'
        },
        matterId: {
            type: 'uuid', entityType: 'matter', required: true,
            comment: 'The Case the person is walled from'
        },
        userId: {
            type: 'uuid', entityType: 'user', required: true,
            comment: 'The walled person'
        },
        reason: {
            type: 'string', required: true,
            comment: 'Sensitive free text explaining why the Ethical Wall was added'
        },
        // Base createdBy records who added the wall; addedBy is the latest writer.
        // Later wall routes read createdBy. addedAt is the explicit wall event time.
        addedAt: {
            type: 'timestamp', required: true, default: '__NOW__',
            comment: 'When the Ethical Wall was added'
        },
        conflictId: {
            type: 'uuid', entityType: 'conflict',
            comment: 'Optional Conflict Check that prompted the Ethical Wall'
        }
    }
});
    }
}
export default EthicalWall;
